// <accordion-group>: buttons (.acc-btn) that each open the panel they control (aria-controls), one open at a time.
// With data-media (a media query) it only acts while the query matches: on connect everything starts closed, and when
// it stops matching (a resize to desktop) every panel is shown again. Server-rendered markup is open, so without JS
// everything shows.
class AccordionGroup extends HTMLElement {
  connectedCallback() {
    // connectedCallback runs again if the element is moved in the DOM: bind once
    if (this.ready) return;
    this.ready = true;
    this.buttons = [...this.querySelectorAll(".acc-btn")];
    const query = this.dataset.media;
    this.media = query ? matchMedia(query) : null;
    for (const btn of this.buttons) btn.addEventListener("click", () => this.toggle(btn));
    this.media?.addEventListener("change", () => this.sync());
    this.sync();
  }

  get active() {
    return !this.media || this.media.matches;
  }

  panel(btn) {
    return document.getElementById(btn.getAttribute("aria-controls"));
  }

  // matching: all closed, buttons focusable. Not matching: all panels shown, so the buttons read as expanded and
  // leave the tab order (they do nothing there)
  sync() {
    for (const btn of this.buttons) {
      btn.tabIndex = this.active ? 0 : -1;
      const panel = this.panel(btn);
      if (!panel) continue;
      panel.hidden = this.active;
      btn.setAttribute("aria-expanded", this.active ? "false" : "true");
    }
  }

  // opening one closes the others; clicking the open one closes it
  toggle(btn) {
    if (!this.active) return;
    const open = btn.getAttribute("aria-expanded") !== "true";
    for (const b of this.buttons) {
      const isOpen = open && b === btn;
      b.setAttribute("aria-expanded", isOpen ? "true" : "false");
      const panel = this.panel(b);
      if (panel) panel.hidden = !isOpen;
    }
  }
}

if (!customElements.get("accordion-group")) customElements.define("accordion-group", AccordionGroup);
